import CONSTANTS from "../Constants/Constants";
//import ENVIRONMENT from "../Constants/Environment";

import Type1Header from "./HeaderTypes/Type1Header";
import Type4Header from "./HeaderTypes/Type4Header";

function Header(props){

    const {
        agentDetails,
        showSearchPage,
        productType,
        cancel_checkout,
        bookingEngine,
        hasNewMessageFromParent,
        currentParentMessge,
    } = props;
    
    //window.__get_current_product_type
    const IS_DEBUG=false;
    const PRODUCT_TYPES = CONSTANTS?.product_types;
    const isFlightPT = parseInt(productType)===PRODUCT_TYPES?.flights;
    const isStaysPT = parseInt(productType)===PRODUCT_TYPES?.stays;
    const isRentalCarsPT = parseInt(productType)===PRODUCT_TYPES?.rental_cars;

    let _company_name = agentDetails?.company_info?.business_name;
    if(_company_name?.length>15)
        _company_name = (_company_name?.substring(0,8)+"...")

    const headerType = parseInt((bookingEngine.searchPageHeaderCard || 1));

    return <div>
        {
            (headerType === 1) &&
            <Type1Header 
                hasNewMessageFromParent={hasNewMessageFromParent}
                currentParentMessge={currentParentMessge}
                IS_DEBUG={IS_DEBUG}
                bookingEngine={bookingEngine}
                agentDetails={agentDetails}
                _company_name={_company_name}
                _logo_url={agentDetails?.company_info?.logo_url}
                PRODUCT_TYPES={PRODUCT_TYPES}
                isFlightPT={isFlightPT}
                isStaysPT={isStaysPT}
                isRentalCarsPT={isRentalCarsPT}
            />
        }
        {
            (headerType === 4) &&
            <Type4Header 
                hasNewMessageFromParent={hasNewMessageFromParent}
                currentParentMessge={currentParentMessge}
                IS_DEBUG={IS_DEBUG}
                bookingEngine={bookingEngine}
                agentDetails={agentDetails}
                _company_name={_company_name}
                _logo_url={agentDetails?.company_info?.logo_url}
                PRODUCT_TYPES={PRODUCT_TYPES}
                isFlightPT={isFlightPT}
                isStaysPT={isStaysPT}
                isRentalCarsPT={isRentalCarsPT}
            />
        }
    </div>
    
}

export default Header;
